module.exports = __webpack_public_path__ + "static/img/img_jiejue_fangan_banner_small.4ace0746.png";